<div class="sidebar-container">
  <!-- Header -->
  <div class="sidebar-header">
    <div class="flex items-center gap-2">
      <h3 class="text-sm font-semibold sm:text-base">{{ 'routing.SUB_ROUTE_PARTNERS.SIDEBAR.TITLE' | t }}</h3>
      <span class="count-badge">{{ totalItems() }}</span>
    </div>
    <div class="flex items-center gap-1">
      <app-bp-grouping-selector [value]="groupingCriteria()" (valueChange)="onGroupingChange($event)" />
      <!-- Desktop: Individual buttons -->
      <button
        mat-icon-button
        (click)="openMapModal()"
        color="primary"
        [matTooltip]="'routing.SUB_ROUTE_PARTNERS.SIDEBAR.MAP_TOOLTIP' | t"
        class="hidden sm:inline-flex"
      >
        <mat-icon svgIcon="heroicons_solid:map-pin"></mat-icon>
      </button>
      <button
        mat-icon-button
        (click)="onExportButtonPressed()"
        [matTooltip]="
          viewMode() === 'group'
            ? ('routing.SUB_ROUTE_PARTNERS.SIDEBAR.EXPORT_DISABLED_TOOLTIP' | t)
            : ('GENERAL.EXPORT' | t)
        "
        [disabled]="viewMode() === 'group'"
        class="hidden sm:inline-flex"
      >
        <mat-icon svgIcon="heroicons_outline:document-arrow-down"></mat-icon>
      </button>
      <!-- Mobile: Overflow menu -->
      <button mat-icon-button [matMenuTriggerFor]="mobileActionsMenu" class="sm:hidden">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #mobileActionsMenu="matMenu">
        <button mat-menu-item (click)="openMapModal()">
          <mat-icon svgIcon="heroicons_solid:map-pin"></mat-icon>
          <span>{{ 'routing.SUB_ROUTE_PARTNERS.SIDEBAR.MAP_TOOLTIP' | t }}</span>
        </button>
        <button mat-menu-item (click)="onExportButtonPressed()" [disabled]="viewMode() === 'group'">
          <mat-icon svgIcon="heroicons_outline:document-arrow-down"></mat-icon>
          <span>{{ 'GENERAL.EXPORT' | t }}</span>
        </button>
      </mat-menu>
    </div>
  </div>

  <!-- Search -->
  <div class="sidebar-search">
    <mat-form-field class="w-full" subscriptSizing="dynamic">
      <mat-icon matPrefix class="mr-2">search</mat-icon>
      <input
        matInput
        type="text"
        [placeholder]="'routing.SUB_ROUTE_PARTNERS.SIDEBAR.SEARCH_PLACEHOLDER' | t"
        [ngModel]="searchTerm()"
        (ngModelChange)="searchTerm.set($event)"
      />
      @if (searchTerm()) {
        <button matSuffix mat-icon-button (click)="searchTerm.set('')">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
  </div>

  <!-- Selection Bar -->
  @if (selectedIds().size > 0) {
    <div class="selection-bar">
      <span class="text-sm font-medium">
        {{ 'routing.SUB_ROUTE_PARTNERS.SIDEBAR.SELECTED_COUNT' | t: { count: selectedIds().size } }}
      </span>
      <div class="flex items-center gap-1">
        <button
          mat-icon-button
          color="primary"
          (click)="openBulkCalendarModal()"
          [matTooltip]="'routing.SUB_ROUTE_PARTNERS.SIDEBAR.ASSIGN_FREQ_SELECTED_TOOLTIP' | t"
        >
          <mat-icon svgIcon="heroicons_outline:calendar-days"></mat-icon>
        </button>
        <button mat-icon-button (click)="clearSelection()" [matTooltip]="'routing.SUB_ROUTE_PARTNERS.SIDEBAR.CLEAR_SELECTION_TOOLTIP' | t">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  }

  <!-- Content: Switch between List and Group views -->
  @switch (viewMode()) {
    @case ('list') {
      <!-- Partners List with Infinite Scroll -->
      <div class="partners-list" #scrollContainer (scroll)="onScroll($event)">
        <!-- Loading Initial -->
        @if (loading() && data().length === 0) {
          <div class="loading-state">
            <mat-spinner diameter="32"></mat-spinner>
            <span class="text-secondary mt-2 text-sm">{{ 'GENERAL.LOADING' | t }}</span>
          </div>
        }

        <!-- Partners Cards -->
        @for (partner of data(); track partner._id) {
          <app-partner-card
            [partner]="partner"
            [companyId]="companyId()"
            [selected]="isSelected(partner._id)"
            [disableIndividualCalendar]="selectedIds().size > 1"
            (selectionChange)="onSelectionChange(partner._id, $event)"
            (openCalendar)="openCalendarModal(partner)"
          />
        }

        <!-- Loading More Indicator -->
        @if (loadingMore()) {
          <div class="loading-more">
            <mat-spinner diameter="24"></mat-spinner>
            <span class="text-secondary ml-2 text-xs">{{ 'routing.SUB_ROUTE_PARTNERS.SIDEBAR.LOADING_MORE' | t }}</span>
          </div>
        }

        <!-- Empty State -->
        @if (data().length === 0 && !loading()) {
          <div class="empty-state">
            <mat-icon class="text-hint icon-size-16">person_off</mat-icon>
            <p class="text-secondary mt-4 text-sm">
              {{
                searchTerm()
                  ? ('routing.SUB_ROUTE_PARTNERS.SIDEBAR.EMPTY_SEARCH' | t)
                  : ('routing.SUB_ROUTE_PARTNERS.SIDEBAR.EMPTY_NONE' | t)
              }}
            </p>
            @if (searchTerm()) {
              <p class="text-hint mt-1 text-xs">{{ 'routing.SUB_ROUTE_PARTNERS.SIDEBAR.EMPTY_HINT' | t }}</p>
            }
          </div>
        }
      </div>
    }
    @case ('group') {
      <!-- Grouped View -->
      <div class="grouped-view">
        <app-unassigned-partners-grouped />
      </div>
    }
  }
</div>
